import * as React from 'react'
import { Form, Icon, Input, Button, Checkbox, message } from 'antd'
import styles from './style.module.styl'
import { connect } from 'react-redux'
import { login } from './actions'

const mapStateToProps = (state: any) => ({
  isLogin: state.login.isLogin,
  isLoading: state.login.isLoading,
  remember: state.login.remember
})

const mapDispatchToProps = {
  login
}


class View extends React.Component<any> {
  handleSubmit = (e: any) => {
    e.preventDefault()
    this.props.form.validateFields(async (err: any, values: any) => {
      if (!err) {
        console.log('Received values of form: ', values)
        this.props.login(values).then((res: any) => {
          if (res.status === 1) {
            this.props.history.replace('/home')
          } else {
            message.error(res.message)
          }
        }).catch((err: any) => {
          message.error('登录失败，请检查账号信息')
        })
      }
    })
  }

  componentDidMount() {
    let remember = window.localStorage.getItem('remember')
    let bool = remember === 'true' ? true : false
    this.props.form.setFieldsValue({
      remember: bool
    })
    bool && this.props.history.replace('/home')
  }

  public render() {
    const { getFieldDecorator } = this.props.form

    return (
      <div className={styles.container}>
        <div className={styles.loginWrap} >
          <div className={styles.logo}>
            无人机云调度平台
          </div>
          {/* <Form onSubmit={this.handleSubmit} className="login-form" autoComplete="new-password"> */}
          <Form onSubmit={this.handleSubmit} className={styles.loginForm}>
            <Form.Item>
              {getFieldDecorator('username', {
                rules: [{ required: true, message: '请输入用户名!' }],
              })(
                <Input
                  className={styles.loginFormInput}
                  disabled={this.props.isLoading}
                  prefix={<Icon type="user" />}
                  placeholder="用户名"
                />
              )}
            </Form.Item>
            <Form.Item>
              {getFieldDecorator('password', {
                rules: [{ required: true, message: '请输入密码!' }],
              })(
                <Input.Password
                  className={styles.loginFormInput}
                  disabled={this.props.isLoading}
                  prefix={<Icon type="lock" />}
                  type="password"
                  placeholder="密码"
                />
              )}
            </Form.Item>
            <Form.Item>
              {getFieldDecorator('remember', {
                valuePropName: 'checked',
                initialValue: true,
              })(<Checkbox disabled={this.props.isLoading}>自动登录</Checkbox>)}
              <div className={styles.loginFormSubmitWrap}>
                <Button loading={this.props.isLoading} type="primary" htmlType="submit" className={styles.loginFormSubmit} style={{ width: '100%' }}>登录</Button>
              </div>
            </Form.Item>
          </Form>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(View))